<template>
	<div>
		<v-navigation-drawer
			v-model="choosingWinner"
			:width="clientWidth"
			fixed
			right
			:temporary="!toggle.prizePicker"
			:permanent="toggle.prizePicker"
			class="winners-choose-picker pa-3">

			<v-card flat class="mb-5 winners-selection">
				<v-card-title primary-title class="pa-0">
					<h1 class="headline">Choose Winners</h1>
				</v-card-title>

				<v-card-text v-if="prize" class="pb-0 px-0">
					<selected-criteria v-model="criteria"></selected-criteria>
					<div class="py-1 selection-info">
						<div :class="{'-transparent': !idSelected.length}">
							{{ idSelected.length }} candidate(s) selected, <v-btn depressed small @click="clearCandidates">Clear</v-btn>
						</div>
						<v-spacer></v-spacer>
						
						<v-btn @click="openPrizePicker" depressed v-if="prizesToBeSubtracted.length">
							<v-icon left>group_remove</v-icon>
							<v-badge color="red">
								<template v-slot:badge>
									<span>{{ prizesToBeSubtracted.length }}</span>
								</template>
								Exclude
							</v-badge>
						</v-btn>
						<v-btn @click="openPrizePicker" depressed v-else><v-icon left>group_remove</v-icon> Exclude</v-btn>

						<v-menu v-model="toggle.selectHeaderMenu" bottom left :close-on-content-click="false">
							<template v-slot:activator="{ on }">
								<v-btn depressed icon v-on="on">
									<v-icon>view_column</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-tile v-for="(header, i) in headersSelectable" :key="`selectable-field-${i}`">
									<v-checkbox v-model="selectedHeaderFields" :label="header.label" :value="header.field"></v-checkbox>
								</v-list-tile>
								<v-list-tile>
									<v-btn block small depressed class="mx-0" @click="toggle.selectHeaderMenu = false">Close</v-btn>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</v-card-text>

				<v-card-text class="candidates-list pt-0 px-0">
					<v-text-field 
						v-model="searchTerm"
						label="Search Table" 
						prepend-inner-icon="search" 
						height="32"
						clearable
						box 
						single-line 
						hide-details>
					</v-text-field>

					<vue-good-table
						ref="candidate-table"
						:max-height="maxTableHeight"
						:key="tableKey"
						:fixed-header="true"
	      				:columns="selectedHeaders"
	      				:rows="filteredCandidates.filter(row => !exclusionWinnerList.includes(row.userId))"
	      				:search-options="{
	    					// enabled: true,
	    					multipleColumns: true,
	    					externalQuery: searchTerm
	    				}">
	    				<template slot="table-row" slot-scope="props">
							<label v-if="props.column.field == 'userId'"class="user-id-seletion" :for="`check-user-id-${props.formattedRow[props.column.field]}`" >
								<input 
									type="checkbox" v-model="idSelected" 
									:id="`check-user-id-${props.formattedRow[props.column.field]}`"
									:value="props.formattedRow[props.column.field]" />
								<span v-html="props.formattedRow[props.column.field]"></span>
							</label>
							<a v-else-if="props.column.field == 'username'" :href="`https://www.jeban.com/mypage/${props.formattedRow.userId}`" target="_blank" v-html="props.formattedRow.username"></a>
							<span v-else-if="props.column.field && props.column.hasOwnProperty('type') && props.column.type == 'number'">
								{{ (props.formattedRow[props.column.field] || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
							</span>
							<span v-else>
								{{ props.formattedRow[props.column.field] }}
							</span>
						</template>
	  				</vue-good-table>
				</v-card-text>

				<v-card-actions class="px-0">
					<v-btn color="primary" @click="applySelections" v-html="`Apply ${totalSelected > 0 ? ` (${totalSelected})` : ''}`">Apply</v-btn>
					<v-btn flat @click="$emit('close')">Cancel</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="randomWinners" v-html="`Random ${maxCandidates} Winner${(maxCandidates > 1) ? 's': ''}`"></v-btn>
				</v-card-actions>
			</v-card>
		</v-navigation-drawer>

		<prize-picker 
			:title="'Exclude winners from ..'" 
			:show="toggle.prizePicker" 
			:selectedPrizes="prizesToBeSubtracted"
			@action="subtractWinners"
			@close="toggle.prizePicker = false">
		</prize-picker>
	</div>
</template>

<script>
	import * as config from '@/config'

	import 'vue-good-table/dist/vue-good-table.css'

	import { VueGoodTable } from 'vue-good-table'
	import SelectedCriteria from '@/components/SelectedCriteria.vue'
	import PrizePicker from '@/components/PrizePicker.vue'

	export default {
		components: {
			'vue-good-table': VueGoodTable,
			'selected-criteria': SelectedCriteria,
			'prize-picker': PrizePicker
		},
		props: {
			prize: {
				type: Object,
				default: null
			},
			candidates: {
				type: Array,
				default: () => []
			},
			ignoredUserIds: {
				type: Array,
				default: () => []
			}
		},
		data () {
			return {
				choosingWinner: false,
				selected: [],
				idSelected: [],
				// totalSelected: 0,
				search: '',
				headersMustHave: [
					{ 
						label: 'Id',
						field: 'userId',		
						type: 'number',	
						thClass: 'text-center',
						tdClass: 'text-center'
					},
					{ label: 'Login', 			field: 'username' },
				],
				headersSelectable: [
					{ label: 'Gender',			field: 'gender' },
					{ label: 'Age',				field: 'age' },
					{ label: 'Skin Tone', 		field: 'skinTone' },
					{ label: 'Skin Condition', 	field: 'skinCondition' },
					{ label: 'Hair Color', 		field: 'hairColor' },
					{ label: 'Skin Problems', 	field: 'skinProblems' },
					{ label: 'Hair Problems', 	field: 'hairProblems' },
					{ label: 'Body Problems', 	field: 'bodyProblems' },
					{ label: 'Topics', 			field: 'topics',				type: 'number'},
					{ label: 'Unpublished', 	field: 'unpublishedTopics',		type: 'number'},
					{ label: 'Reviews', 		field: 'reviews',				type: 'number'},
					{ label: 'Comments', 		field: 'comments',				type: 'number'},
					{ label: 'Join', 			field: 'totalJoin',				type: 'number'},
					{ label: 'Won', 			field: 'totalPrizeWin',			type: 'number'},
					{ label: 'Haul', 			field: 'totalGiveawayTopics',	type: 'number'},
				],
				defaultHeaderFields: ['topics', 'unpublishedTopics', 'reviews', 'comments', 'totalJoin', 'totalPrizeWin', 'totalGiveawayTopics'],
				selectedHeaderFields: [],
				criteria: () => {},
				searchTerm: '',
				tableKey: 1,
				toggle: {
					selectHeaderMenu: false,
					prizePicker: false
				},
				prizesToBeSubtracted: [],
				exclusionWinnerList: []
			}
		},
		computed: {
			clientWidth () 
			{
				return window.innerWidth
			},
			maxTableHeight () {
				return `${(window.innerHeight - 320).toString()}px`
			},
			maxCandidates ()
			{
				return this.prize ? this.prize.numberOfWinners - this.prize.winners.length : 0
			},
			totalSelected () {
				return this.idSelected.length
			},
			headersSelected () {
				return this.headersSelectable.filter(h => this.selectedHeaderFields.includes(h.field))
			},
			selectedHeaders () {
				return this.headersMustHave.concat(this.headersSelected)
			},
			filteredCandidates () 
			{
				return [...new Map(this.candidates.filter(c => {
					let matched = true

					matched = (c.hasAddress == 1) ? true : false

					if (this.ignoredUserIds.length > 0) {
						matched = matched && !this.ignoredUserIds.includes(c.userId)
					}

					if (this.criteria && this.criteria.hasOwnProperty('genders') && this.criteria.genders.length > 0) {
						matched = matched && this.criteria.genders.includes(c.gender)
					}
					if (this.criteria && this.criteria.hasOwnProperty('ages') && this.criteria.ages.length > 0) {
						if (parseInt(this.criteria.ages[0]) > 0) {
							matched = matched && (parseInt(c.age) >= parseInt(this.criteria.ages[0]))
						}
						if (parseInt(this.criteria.ages[1]) > 0) {
							matched = matched && (parseInt(c.age) <= parseInt(this.criteria.ages[1]))
						}
					}
					if (this.criteria && this.criteria.hasOwnProperty('skinTones') && this.criteria.skinTones.length > 0) {
						matched = matched && this.criteria.skinTones.includes(c.skinTone)
					}
					if (this.criteria && this.criteria.hasOwnProperty('skinConditions') && this.criteria.skinConditions.length > 0) {
						matched = matched && this.criteria.skinConditions.includes(c.skinCondition)
					}
					if (this.criteria && this.criteria.hasOwnProperty('hairColors') && this.criteria.hairColors.length > 0) {
						matched = matched && this.criteria.hairColors.includes(c.hairColor)
					}
					if (this.criteria && this.criteria.hasOwnProperty('hairConditions') && this.criteria.hairConditions.length > 0) {
						matched = matched && this.criteria.skinConditions.includes(c.hairCondition)
					}
					if (this.criteria && this.criteria.hasOwnProperty('skinProblems') && this.criteria.skinProblems.length > 0) {
						if (c.skinProblems && Array.isArray(JSON.parse(c.skinProblems))) {
							if (this.criteria.skinProblemsAll) {
								matched = matched && this.criteria.skinProblems.every(p => JSON.parse(c.skinProblems).includes(p))
							} else {
								matched = matched && this.criteria.skinProblems.some(p => JSON.parse(c.skinProblems).includes(p))
							}
						} else {
							matched = false
						}
					}
					if (this.criteria && this.criteria.hasOwnProperty('bodyProblems') && this.criteria.bodyProblems.length > 0) {
						if (c.bodyProblems && Array.isArray(JSON.parse(c.bodyProblems))) {
							if (this.criteria.bodyProblemsAll) {
								matched = matched && this.criteria.bodyProblems.every(p => JSON.parse(c.bodyProblems).includes(p))
							} else {
								matched = matched && this.criteria.bodyProblems.some(p => JSON.parse(c.bodyProblems).includes(p))
							}
						} else {
							matched = false
						}
					}
					if (this.criteria && this.criteria.hasOwnProperty('hairProblems') && this.criteria.hairProblems.length > 0) {
						if (c.hairProblems && Array.isArray(JSON.parse(c.hairProblems))) {
							if (this.criteria.hairProblemsAll) {
								matched = matched && this.criteria.hairProblems.every(p => JSON.parse(c.hairProblems).includes(p))
							} else {
								matched = matched && this.criteria.hairProblems.some(p => JSON.parse(c.hairProblems).includes(p))
							}
						} else {
							matched = false
						}
					}

					return matched
				}).map(f => {
					let o = {}

					this.headersMustHave.map(m => m.field).concat(this.selectedHeaderFields).forEach(h => {
						o[h] = f[h]
					})

					return o
				}).map(item => [item['userId'], item])).values()]
			},
		},
		methods: {
			// onCellClick (params) {
			// 	if (['userId'].includes(params.column.field)) {
			// 		if (!this.idSelected.includes(params.row.userId)) {
			// 			if (this.idSelected.length < this.maxCandidates) {
			// 				this.idSelected.push(params.row.userId)
			// 			} else {
			// 				this.$swal({
			// 					title: 'Warning!',
			// 					text: `Only ${this.prize.numberOfWinners} winner(s) allowed in "${this.prize.title}".`,
			// 					icon: 'warning',
			// 				})
			// 			}
			// 		} else {
			// 			this.idSelected.splice(this.idSelected.indexOf(params.row.userId), 1)
			// 			this.tableKey++
			// 		}
			// 	}
			// },
			clearCandidates () {
				this.idSelected = []
				this.tableKey++
			},
			validateMaxSelection () {
				if (this.idSelected.length > this.maxCandidates) {
					this.$swal({
						title: 'Warning!',
						text: `Only ${this.prize.numberOfWinners} winner(s) allowed in "${this.prize.title}".`,
						icon: 'warning',
					})
					return false
				} else {
					return true
				}
			},
			applySelections () {
				if (this.validateMaxSelection()) {
					this.$emit('selected', this.filteredCandidates.filter(c => this.idSelected.includes(c.userId)))
				}
			},
			randomWinners () {
				if (this.candidates <= this.maxCandidates) {
					this.$emit('selected', JSON.parse(JSON.stringify(this.filteredCandidates)))
				} else {
					let allC = JSON.parse(JSON.stringify(this.filteredCandidates))
					let selC = []

					for (let i = 0; i < this.maxCandidates; i++) {
						let j = Math.floor((Math.random() * (allC.length - 1)))

						selC.push(allC[j])
						allC.splice(j, 1)
					}

					this.$emit('selected', selC)
				}
			},
			selectDefaultColumns () {
				this.selectedHeaderFields = this.defaultHeaderFields

				if (this.criteria && this.criteria.hasOwnProperty('selects')) {
					this.selectedHeaderFields = this.selectedHeaderFields.concat(this.criteria.selects.map(s => s.replace('Problem', 'Problems')))
				}
			},
			openPrizePicker () {
				this.toggle.prizePicker = true
			},
			subtractWinners (prize) {
				let index = this.prizesToBeSubtracted.findIndex(z => z.id == prize.id)

				if (index < 0) {
					this.prizesToBeSubtracted.push(prize)
				} else {
					this.prizesToBeSubtracted.splice(index, 1)
				}
				this.toggle.prizePicker = false
			}
		},
		mounted () {
			if (this.prize && this.prize.hasOwnProperty('id')) {
				this.choosingWinner = true
			}
		},
		watch: {
			prize (value) 
			{
				this.choosingWinner = (value && value.hasOwnProperty('id')) ? true : false
				this.clearCandidates()
			},
			choosingWinner (value)
			{
				this.criteria = (value && this.prize && this.prize.hasOwnProperty('criteria')) ? JSON.parse(JSON.stringify(this.prize.criteria)) : {}
			},
			idSelected (newValue, oldValue) {
				if (!this.validateMaxSelection()) {
					this.idSelected.pop()
					this.tableKey++
				}
			},
			criteria: {
				handler (value) {
					this.selectDefaultColumns()
				},
				deep: true
			},
			prizesToBeSubtracted: {
				handler (value) {
					Promise.all(
						this.prizesToBeSubtracted.map(z => axios.get(`${config.BASE_URL}/luckylist/prize/${z.id}/winnersWithAddress`))
					).then(responses => {
						this.exclusionWinnerList = []
						responses.forEach(response => {
							this.exclusionWinnerList = [...new Set(this.exclusionWinnerList.concat(response.data.data.map(w => w.userId)))]
						})
						this.tableKey++
					})
				},
				deep: true
			}
		}
	}
</script>

<style lang="scss">
	.winners-selection {
		display: flex;
		flex-flow: column;
		height: 100%;
		margin-bottom: 0 !important;

		> div:nth-of-type(3) {
			flex: 1;
			overflow: auto;
		}

		.selected-criteria-wrapper {
			margin-bottom: 0 !important;
		}
		.selection-info {
			display: flex;
			flex-flow: row wrap;
			align-items: center;

			.-transparent {
				opacity: 0;
			}
		}

		.candidates-list {
			display: block;
			overflow: auto !important;
			position: relative;
		}

		.v-datatable__actions {
			position: fixed;
			bottom: 16px;
			left: 0;
			width: 100%;
		}

		.text-center {
			text-align: center;
		}
		.user-id-seletion {
			white-space: nowrap;

			display: grid;
			grid-template-columns: repeat(2, auto);
			grid-gap: 10px;
			align-items: center;

			span {
				text-align: right;
			}
		}

		#vgt-table {
			font-size: 13px;

			tbody tr td:nth-of-type(1) {
				cursor: pointer;
				width: 100px;
			}
		}
	}
</style>